import React from "react";
import DashBoardOverview from "./components/DashBoardOverview";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/main.css";

export default () => <DashBoardOverview/>;
